import { Component, OnInit } from '@angular/core';
import {
  IconEnum,
  ControlSizeEnum,
  ControlTypeColorEnum,
  AvatarTypeEnum,
  ControlDisplayEnum,
  DialogRef
} from 'datnek-ds';

interface Items {
  id: number;
  name: string;
  src: string;
  type: string;
}

interface UsersItems {
  imageSrc: string;
  professionalTitle: string;
  name: string;
  society: string;
  groupName: string;
  relations: number;
  sector: string;
}

@Component({
  selector: 'nk-shared-dialog-post-in-group-or-user',
  templateUrl: './dialog-post-in-group-or-user.component.html',
  styleUrls: ['./dialog-post-in-group-or-user.component.scss'],
})
export class DialogPostInGroupOrUserComponent implements OnInit {
  iconEnum = IconEnum;
  sizeEnum = ControlSizeEnum;
  colorEnum = ControlTypeColorEnum;
  avatarEnum = AvatarTypeEnum;
  displayEnum = ControlDisplayEnum;

  items = [{ id: 1 }, { id: 2 }, { id: 3 }];

  meSubmenu: Items[] = [
    {
      id: 0,
      name: 'John Doe',
      src: 'assets/Img/user-placeholder-avatar.svg',
      type: 'person',
    },
    {
      id: 0,
      name: 'DIgitaille_CM',
      src: 'assets/Img/profile_img_jobs.png',
      type: 'society',
    },
    {
      id: 0,
      name: 'Graven Inc.',
      src: 'assets/Img/profile_img_jobs.png',
      type: 'society',
    },
  ];

  dataUsers: UsersItems[] = [
    {
      imageSrc: 'assets/Img/users/1.png',
      professionalTitle: 'Analyste Programmeur et Data Senior',
      name: 'Fara Moiten 2 kkjsfksjd skfjkds fkjhfjksdfh kj fhjsdfdsk',
      society: 'DIGITAILLE Multimedia Intertainement',
      groupName: 'Nom du groupe',
      relations: 4,
      sector: 'Génie civil',
    },
    {
      imageSrc: 'assets/Img/users/1.png',
      professionalTitle: 'Analyste Programmeur',
      name: 'Fara Moiten 2',
      society: 'DIGITAILLE',
      groupName: 'Nom du groupe',
      relations: 18,
      sector: 'Technologie',
    },
    {
      imageSrc: 'assets/Img/users/1.png',
      professionalTitle: 'Analyste Programmeur',
      name: 'Fara Moiten 2',
      society: 'DIGITAILLE',
      groupName: 'Nom du groupe',
      relations: 0,
      sector: 'Agroalimentaire',
    },
    {
      imageSrc: 'assets/Img/users/1.png',
      professionalTitle: 'Analyste Programmeur',
      name: 'Fara Moiten 2',
      society: 'DIGITAILLE',
      groupName: 'Nom du groupe',
      relations: 4,
      sector: 'Génie civil',
    },
    {
      imageSrc: 'assets/Img/users/1.png',
      professionalTitle: 'Analyste Programmeur',
      name: 'Fara Moiten 2',
      society: 'DIGITAILLE',
      groupName: 'Nom du groupe',
      relations: 18,
      sector: 'Technologie',
    },
    {
      imageSrc: 'assets/Img/users/1.png',
      professionalTitle: 'Analyste Programmeur',
      name: 'Fara Moiten 2',
      society: 'DIGITAILLE',
      groupName: 'Nom du groupe',
      relations: 0,
      sector: 'Agroalimentaire',
    },
  ];

  constructor(public ref: DialogRef) {}

  ngOnInit(): void {}

  remove(index: any) {
    this.items.splice(index, 2);
  }

  close() {
    this.ref.close(null);
  }
}
